import mobile from "../assets/mobile.png";
import whatsapp from "../assets/whatsapp.png";
import email from "../assets/email.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import supplyChain from "../assets/supplyChain.png";
import operations from "../assets/operations.png";
import productManagement from "../assets/productManagement.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";
import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

export default {
  mobile,
  whatsapp,
  email,
  cpp,
  css,
  figma,
  flutter,
  git,
  html,
  javascript,
  python,
  react,
  redux,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  supplyChain,
  operations,
  productManagement,
};
